import InputControl from "components/ui/InputControl"

const Checkbox = props => <InputControl type="checkbox" {...props} />

export default Checkbox
